import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import styled from 'styled-components';

const AccessibilityContainer = styled.div` display: flex; margin-left: 10px; `;

const HeaderButton = styled.button` border: 0; outline: 0; padding: 1px 1em; color: #222; font-size: 13px; font-weight: 600; border-radius: 20px; 
                                    background-color: transparent; border: 2px solid #00c9ff; transition: all 240ms ease-in-out; cursor: pointer; 
                                    &:hover { background-color: #00c9ff; } &:not(:last-of-type) { margin-right: 7px; } `;

const FaurtySpacesH = styled.div` width: 40px;`;

export function Accessibility(props) 
{ const { t } = useTranslation();
  const navigate = useNavigate();
                                               
  return ( <AccessibilityContainer>
              <HeaderButton onClick={() => navigate("/")}> {t(`IDX.HeaderBar.Register`)} </HeaderButton>
              <HeaderButton onClick={() => navigate("/")}> {t(`IDX.HeaderBar.Login`)} </HeaderButton>
              <FaurtySpacesH />
              <HeaderButton onClick={() => navigate("/azedmessage")}>{t(`IDX.HeaderBar.ctct_lnk`)}</HeaderButton>
           </AccessibilityContainer>  
         );
}
